import { FeaturesSettingsDTO } from './settingTypes'

import { api, endpoints } from '@/api'

export async function getFeaturesSettings(): Promise<FeaturesSettingsDTO> {
  const res = await api.get(endpoints.settings.features)
  return res.data
}

export const settingApi = {
  getFeaturesSettings,
}
